import gql from 'graphql-tag';
import { transientPersonResponseFragment } from '../guided_attendance/fragment';
import { transientPersonManagementWithDetailsFragment } from './fragment';

export const insertTransientPerson = gql`
  mutation insertTransientPerson($transientPerson: TransientPersonInput!) {
    insertTransientPerson(transientPerson: $transientPerson) {
      ...transientPersonResponseParts
    }
  }
  ${transientPersonResponseFragment}
`;

export const deleteTransientPerson = gql`
  mutation deleteTransientPerson($transientPersonId: ID!) {
    deleteTransientPerson(transientPersonId: $transientPersonId)
  }
`;

export const updateTransientPersonManagement = gql`
  mutation updateTransientPersonManagement(
    $transientPerson: TransientPersonInput!
    $transientPersonId: Int!
  ) {
    updateTransientPersonManagement(
      transientPerson: $transientPerson
      transientPersonId: $transientPersonId
    ) {
      ...transientPersonManagementWithDetailsParts
    }
  }
  ${transientPersonManagementWithDetailsFragment}
`;
